const target = document.querySelector('.template--index .share-main');
const myElement = document.querySelector('.template--index .slider-pagination');
if(myElement){
  window.addEventListener('scroll', () => {
    const rect = target.getBoundingClientRect();
    const isVisible = rect.bottom <= window.innerHeight;
  
    if (isVisible) {
      myElement.style.display = 'none'; // hide
    } else {
      myElement.style.display = 'block'; // show
    }
  });
}

